import api from '@/api/index.js'

const card = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_CARD_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_CARD: (state, data) => {
      state.data = data
      state.loading = false
    },
    SET_CARD_ERROR: (state, error) => {
      state.error = error
      state.loading = false
    }
  },

  actions: {
    LoadCard({commit}, query) {
      commit('SET_CARD', null)
      commit('SET_CARD_ERROR', null)
      commit('SET_CARD_LOADING', true)

      let queryPath = `cards/${query.id}`;
      if (query.byAccountId == true) {
        queryPath = `accounts/${query.id}/card`
      }

      return api.get(queryPath)
        .then((response) => {
          commit('SET_CARD', response)
          commit('SET_CARD_ERROR', null)
        })
        .catch((error) => {
          commit('SET_CARD_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.url + ': ' + error.bodyText)
        })
    }
  },
}

export default card
